import axiosInstance from "../helpers/axiosInstance"

export const getCubboLastmileOrderEvents = async (order_id) => {
    const params = {order_id: order_id}
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/cubbo-lastmile-events/order-events`, {params: params})
    return res.data
}
